import {useModal} from "../../../../hooks";
import useGoToNavigation from "../../../../util/useGotoNavigation";
import SearchProductInner from "../../../../components/common/modal/inner/SearchProductInner";
import {useState} from "react";
import {ProductInDetailType} from "../../../product/internal/detail/interface";
import {productInDetailInit} from "../../../product/internal/detail/state";
import {InvCreateType} from "./interface";
import {invCreateInit} from "./state";
import {useCreateInv} from "./hooks/useCreateInv";
import {SubmitHandler, useForm, useWatch} from "react-hook-form";
import {useCreateInventoryBarcode} from "./hooks/useCreateInventoryBarcode";

export default function InvCreate() {
    const {goToNavigation} = useGoToNavigation();
    const {handleModal} = useModal();

    const {mutate: mutateCreateInv} = useCreateInv()
    const {mutateAsync: mutateAsyncCreateInvBarcode} = useCreateInventoryBarcode()

    const [selectedProduct, setSelectedProduct] = useState<ProductInDetailType>(productInDetailInit)
    const [createData, setCreateData] = useState<InvCreateType>(invCreateInit)

    const {register, handleSubmit, reset, control, setValue} = useForm({
        defaultValues: createData,
    });

    const watchCreateData = {
        ...createData,
        ...useWatch<InvCreateType>({control}),
    };

    const btnSearchProduct = () => {
        handleModal({
            isOpen: true,
            contents: <SearchProductInner
                confirmCallback={(item) =>
                    setSelectedProduct(item.productDetailRes)
                }
                modalDepth={1}
            />,
            type: "",
            title: "제품 조회",
            modalSize: "xxl"
        })
    }

    const btnGoToList = () => {
        goToNavigation("inventory/inv/list", {}, false)
    }

    const btnGenerateBarcode = async () => {
        const barcode = await mutateAsyncCreateInvBarcode().then((res: any) => res.data.result)
        setValue("barcode", barcode, {})
    }

    const onSubmit: SubmitHandler<InvCreateType> = (submitData) => {
        if (selectedProduct.newErpProductid === "") {
            handleModal({
                isOpen: true,
                contents: "제품을 선택해주세요.",
                type: "alert"
            })
        } else {
            mutateCreateInv({...submitData, newErpProductid: selectedProduct.newErpProductid});
        }
    };
    // 내부수정: 검색 버튼 위치 변경
    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">재고 생성</h3>
                    <div className="filter_toolbar">
                        <button
                            className="btn btn-outline-primary w-240px h-38px"
                            onClick={btnGoToList}><img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt="" />
                            목록
                        </button>
                        <button type="button" className="btn btn-primary w-100px ms-5px h-38px"
                                onClick={handleSubmit(onSubmit)}>생성
                        </button>
                    </div>
                </div>

                <h5 className="subheading">제품 정보</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                    <tr>
                        <th style={{width: "16.66%"}}>품목명</th>
                        <td style={{width: "33.32%"}}>
                             <div className="d-flex align-items-center">
                                <span className="flex-grow-1">{selectedProduct.newTxtNmItem}</span>
                                <button type="button" className="btn btn-info color3 w-100px h-38px" onClick={btnSearchProduct}>
                                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>제품 검색
                                </button>
                            </div>
                        </td>
                        <th style={{width: "16.66%"}}>품목코드</th>
                        <td>{selectedProduct.newTxtCdItem}</td>
                    </tr>
                    <tr>
                        <th>벤더</th>
                        <td>{selectedProduct.vendor}</td>
                        <th>대분류</th>
                        <td>{selectedProduct.majorCategory}</td>
                    </tr>
                    <tr>
                        <th>카테고리</th>
                        <td>{selectedProduct.category}</td>
                        <th>중분류</th>
                        <td>{selectedProduct.subCategory}</td>
                    </tr>
                    <tr>
                        <th>규격</th>
                        <td>{selectedProduct.newTxtStndItem}</td>
                        <th>사업부별 제품군</th>
                        <td>{selectedProduct.productRange}</td>
                    </tr>
                    </tbody>
                </table>

                <h5 className="subheading mt-20px">재고 정보</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                    <tr>
                        <th style={{width: "16.66%"}}>단위 <span className="required">*</span></th>
                        <td style={{width: "33.32%"}} className="p-4px"><input type="text" className="form-control"
                                                                               value={watchCreateData.inventoryUnit} {...register("inventoryUnit")}/>
                        </td>
                        <th style={{width: "16.66%"}}>안전재고</th>
                        <td className="p-4px"><input type="text" className="form-control"
                                                     value={watchCreateData.safetyAmount} {...register("safetyAmount")}/>
                        </td>
                    </tr>
                    <tr>
                        <th>구매가</th>
                        <td className="p-4px"><input type="text" className="form-control"
                                                     value={watchCreateData.originalPrice} {...register("originalPrice")}/>
                        </td>
                        <th>판매가</th>
                        <td className="p-4px"><input type="text" className="form-control"
                                                     value={watchCreateData.sellingPrice} {...register("sellingPrice")}/>
                        </td>
                    </tr>
                    <tr>
                        <th>바코드</th>
                        <td className="p-4px">
                            <div className="d-flex align-items-center">
                                <input type="text" className="form-control"
                                       value={watchCreateData.barcode} {...register("barcode")}/>
                                <button className="btn btn-dark ms-1 w-130px h-30px" onClick={btnGenerateBarcode}>바코드
                                    생성
                                </button>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </>
    );
}